<template>
  <div class="pk-chrome">
    <section class="pk-live" aria-label="实时掉落展示">
      <transition-group name="pk-live-drop" tag="div" class="pk-live-track">
        <button
          v-for="drop in liveDrops"
          :key="drop.key"
          class="pk-live-item"
          :class="{
            'pk-live-item-link': drop.boxId,
            'has-rarity-background': drop.rarityBackground,
          }"
          :style="{
            '--pk-drop-color': drop.rarityColor,
            '--pk-drop-background': drop.rarityBackground ? 'url(' + drop.rarityBackground + ')' : 'none',
          }"
          type="button"
          @click="openDrop(drop)"
        >
          <img :src="drop.img" :data-fallback="defaultDropImage" alt="" @error="replaceDropImage" />
          <span v-if="drop.isStattrak" class="pk-live-stattrak">★</span>
          <strong>{{ drop.price }}</strong>
          <span class="pk-live-tooltip">
            <img :src="drop.playerImg" :data-fallback="defaultAvatar" alt="" @error="replacePlayerImage" />
            <span>
              <b>{{ drop.title || drop.name }}</b>
              <em>{{ drop.playerName }}</em>
              <small>从 {{ drop.boxName || "打开箱子" }} 掉落</small>
              <i class="pk-live-tooltip-price"><span>{{ drop.price }}</span><span class="pk-live-pizza-icon" aria-label="披萨币"></span></i>
            </span>
          </span>
        </button>
      </transition-group>
    </section>
    <aside class="pk-chrome-side">
      <div class="pk-chrome-top">
        <div class="pk-top-meta">
          <span class="pk-language"><i class="pk-flag"></i>简体</span>
          <span class="pk-online"><i></i>{{ onlineCount }}</span>
        </div>
        <button class="pk-balance" @click="go('/Payment')"><i></i>{{ formattedMoney }}<b>+</b></button>
      </div>
      <div class="pk-sound" :class="{ muted: !soundEnabled }">
        <button class="pk-sound-toggle" type="button" :aria-label="soundEnabled ? '静音' : '开启声音'" @click="toggleSound">
          <span></span>
        </button>
        <input
          class="pk-sound-range"
          type="range"
          min="0"
          max="100"
          step="1"
          :value="soundVolume"
          :style="{ '--pk-sound-volume': soundVolume + '%' }"
          aria-label="音量"
          @input="setSoundVolume"
        />
        <span class="pk-sound-max" aria-hidden="true"></span>
        <em>{{ soundEnabled ? `音量 ${soundVolume}%` : "已静音" }}</em>
      </div>
      <button class="pk-logo" type="button" aria-label="返回首页" @click="go('/Index')">
        <img src="../assets/pizzaking/dynamic-logo-mark.png" alt="" />
        <span>PizzaKing<small>-CJ</small></span>
      </button>
      <button class="pk-mobile-battle-link" type="button" @click="openMode(modes[2])">
        <span
          :style="{
            WebkitMaskImage: 'url(' + modes[2].icon + ')',
            maskImage: 'url(' + modes[2].icon + ')',
          }"
        ></span>
        <b>箱子战斗</b>
        <em>敬请期待</em>
      </button>
      <div class="pk-login-label">登录</div>
      <button v-if="!loggedIn" class="pk-auth-main" @click="$emit('login')">手机号登录</button>
      <div v-if="!loggedIn" class="pk-auth-actions">
        <button @click="$emit('register')">注册账号</button>
        <button @click="$emit('login')">密码登录</button>
      </div>
      <button v-else class="pk-user-card" @click="accountMenuVisible = !accountMenuVisible">
        <strong>{{ displayName }}</strong>
        <span class="pk-user-currencies">
          <span class="pk-currency pizza" title="披萨币" aria-label="披萨币余额"><i></i><b>{{ formattedMoney }}</b></span>
          <span class="pk-currency wheat" title="小麦币" aria-label="小麦币余额"><i></i><b>{{ formattedMasonry }}</b></span>
          <span class="pk-currency cheese" title="奶酪币" aria-label="奶酪币余额"><i></i><b>{{ formattedCheese }}</b></span>
          <span class="pk-currency key" title="特殊钥匙" aria-label="特殊钥匙数量"><i></i><b>{{ formattedSpecialKey }}</b></span>
        </span>
      </button>
      <section v-if="loggedIn && accountMenuVisible" class="pk-account-popover">
        <header>
          <div class="pk-account-avatar"><img :src="accountAvatar" alt="" @error="replaceAccountAvatar" /></div>
          <div><span>个人账户</span><strong>{{ displayName }}</strong></div>
          <button type="button" aria-label="关闭账户菜单" @click="accountMenuVisible = false">×</button>
        </header>
        <div class="pk-account-balances">
          <span class="pk-currency pizza" title="披萨币：充值获取，用于打开箱子、拉货、箱子战斗和站内正常玩法"><i></i><b>{{ formattedMoney }}</b></span>
          <span class="pk-currency wheat" title="小麦币：饰品兑换自动获得，用于小麦商城，也可兑换为披萨币"><i></i><b>{{ formattedMasonry }}</b></span>
          <span class="pk-currency cheese" title="奶酪币：活动或任务获取，用于特殊箱子和专属币种玩法"><i></i><b>{{ formattedCheese }}</b></span>
          <span class="pk-currency key" title="特殊钥匙：用于开启对应特殊箱子"><i></i><b>{{ formattedSpecialKey }}</b></span>
        </div>
        <div class="pk-account-actions">
          <button type="button" @click="openAccountPath('/Me')">个人中心</button>
          <button type="button" @click="openAccountPath('/Dota')">我的背包</button>
          <button type="button" @click="openAccountPath('/Bill')">我的账单</button>
          <button type="button" @click="openAccountPath('/Inform')">取回记录</button>
          <button type="button" class="currency-exchange-action" @click="openAccountPath('/CurrencyExchange')">小麦转换</button>
        </div>
        <button type="button" class="pk-account-logout" @click="logout">退出登录</button>
      </section>
      <button v-if="loggedIn" class="pk-notice-link" @click="go('/Inform')">
        <i></i>
        消息通知
        <em v-if="unreadCount > 0">{{ unreadCount > 99 ? "99+" : unreadCount }}</em>
      </button>
      <button class="pk-side-link pk-link-spread" @click="go('/Spread')"><i></i>合作伙伴计划</button>
      <button class="pk-side-link pk-link-freecase" @click="go('/activity')"><i></i>福利箱子</button>
      <button class="pk-side-link pk-link-mall" @click="go('/WheatMall')"><i></i>小麦商城</button>
      <button class="pk-side-link pk-link-ouhuang" @click="go('/Ouhuang')"><i></i>欧皇争霸</button>
      <button class="pk-side-link pk-link-promotion" @click="go('/PromotionCenter')"><i></i>活动中心</button>
      <button class="pk-side-link pk-task-link" @click="go('/task-center')"><i></i>任务中心</button>
      <button class="pk-side-link pk-link-cooperation" @click="goCooperation"><i></i>客服中心</button>
      <button class="pk-side-link pk-link-notice" @click="go('/Inform')"><i></i>消息通知</button>
      <button class="pk-side-link pk-support-link" @click="go('/Doubt')"><i></i>支持与反馈</button>
      <div v-if="freeDrop" class="pk-free-drop">
        <div class="pk-free-drop-money">{{ freeDrop.price_text }}</div>
        <div class="pk-free-drop-time"><span>剩余时间:</span> {{ freeDrop.time_text }}</div>
        <img :src="freeDrop.image_url || defaultFreeDropImage" alt="" />
        <strong>{{ freeDrop.title }}</strong>
        <em>{{ freeDrop.subtitle }}</em>
        <button @click="openPromotion(freeDrop)">{{ freeDrop.button_text }}</button>
      </div>
      <div v-if="bonusAd" class="pk-bonus-ad">
        <b>{{ bonusAd.title }}</b>
        <span>{{ bonusAd.subtitle }}</span>
        <button @click="openPromotion(bonusAd)">{{ bonusAd.button_text }}</button>
      </div>
      <button class="pk-scroll-toggle" type="button" @click="togglePageScroll">
        {{ atPageTop ? "前往底部" : "返回顶部" }}
        <i :class="{ up: !atPageTop }"></i>
      </button>
    </aside>
    <button class="pk-support-float" type="button" aria-label="打开客服支持" @click="toggleSupportPanel">
      <i></i>
      <span>客服支持</span>
      <em v-if="unreadCount > 0">{{ unreadCount > 99 ? "99+" : unreadCount }}</em>
    </button>
    <section v-if="supportPanelVisible" class="pk-support-panel" aria-label="站内客服支持">
      <header>
        <div>
          <span>客服支持</span>
          <strong>站内工单支持</strong>
        </div>
        <button type="button" aria-label="关闭客服支持" @click="supportPanelVisible = false">×</button>
      </header>
      <template v-if="!loggedIn">
        <p>登录后可提交问题，并在站内通知中查看客服回复。</p>
        <button type="button" class="pk-support-login" @click="openSupportLogin">登录后提交工单</button>
      </template>
      <template v-else>
        <div v-if="supportFeedback.length" class="pk-support-history">
          <article v-for="item in supportFeedback" :key="item.id">
            <strong>{{ item.title }}</strong>
            <span>{{ item.status_name || "处理中" }}</span>
            <p v-if="item.reply">客服：{{ item.reply }}</p>
          </article>
        </div>
        <p v-else class="pk-support-empty">暂无工单记录。</p>
        <input v-model.trim="supportForm.title" maxlength="120" placeholder="问题标题" />
        <textarea v-model.trim="supportForm.content" placeholder="请简要描述问题或订单号"></textarea>
        <div class="pk-support-actions">
          <button type="button" class="pk-support-detail" @click="goSupportPage">查看全部</button>
          <button type="button" class="pk-support-submit" @click="submitQuickFeedback">提交工单</button>
        </div>
      </template>
    </section>
    <main class="pk-chrome-main">
      <section class="pk-modes">
        <button
          v-for="mode in modes"
          :key="mode.title"
          :class="[{ active: active === mode.key, unavailable: !mode.available }, 'mode-' + mode.key]"
          @click="openMode(mode)"
        >
          <span
            :style="{
              WebkitMaskImage: 'url(' + mode.icon + ')',
              maskImage: 'url(' + mode.icon + ')',
            }"
          ></span>
          <em v-if="mode.badge || !mode.available">{{ mode.badge || "敬请期待" }}</em>
          <b>{{ mode.title }}</b>
        </button>
      </section>
    </main>
    <nav class="pk-mobile-nav" aria-label="手机端快捷导航">
      <button :class="{ active: active === 'case' }" type="button" aria-label="打开箱子" @click="go('/Index')">
        <span
          :style="{
            WebkitMaskImage: 'url(' + modes[0].icon + ')',
            maskImage: 'url(' + modes[0].icon + ')',
          }"
        ></span>
      </button>
      <button class="cheese" :class="{ active: active === 'cheese' }" type="button" aria-label="奶酪秘境" @click="openMode(modes[1])">
        <span
          :style="{
            WebkitMaskImage: 'url(' + modes[1].icon + ')',
            maskImage: 'url(' + modes[1].icon + ')',
          }"
        ></span>
      </button>
      <button class="battle" :class="{ active: active === 'battle' }" type="button" aria-label="箱子战斗，敬请期待" @click="openMode(modes[2])">
        <span
          :style="{
            WebkitMaskImage: 'url(' + modes[2].icon + ')',
            maskImage: 'url(' + modes[2].icon + ')',
          }"
        ></span>
        <em>敬请期待</em>
      </button>
      <button class="inventory" type="button" aria-label="我的背包" @click="loggedIn ? go('/Dota') : $emit('login')">
        <span></span>
      </button>
    </nav>
  </div>
</template>

<script>
import { OPENBOX_ONLY_LAUNCH } from "@/config";

export default {
  name: "PizzaChrome",
  props: {
    active: {
      type: String,
      default: "case",
    },
    loggedIn: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      default: "",
    },
    userAvatar: {
      type: String,
      default: "",
    },
    money: {
      type: [Number, String],
      default: 0,
    },
    masonry: {
      type: [Number, String],
      default: 0,
    },
    cheese: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    formattedMoney() {
      return Number(this.money).toFixed(2);
    },
    formattedMasonry() {
      return Number(this.masonry).toFixed(2);
    },
    formattedCheese() {
      return Number(this.cheese).toFixed(2);
    },
    formattedSpecialKey() {
      return Number(this.specialKeyBalance || 0).toFixed(0);
    },
    displayName() {
      return this.userName || "我的账户";
    },
    defaultAccountAvatar() {
      return require("../assets/img/jiapeople.png");
    },
    accountAvatar() {
      return this.userAvatar || this.defaultAccountAvatar;
    },
    freeDrop() {
      return this.promotions.find((item) => item.slot_key === "free_drop" && Number(item.enabled) === 1);
    },
    bonusAd() {
      return this.promotions.find((item) => item.slot_key === "bonus_ad" && Number(item.enabled) === 1);
    },
  },
  data() {
    const iconOpenCase = require("../assets/pizzaking/mode-open-case.svg");
    const iconCheese = require("../assets/pizzaking/cheese-token.svg");
    const iconBattle = require("../assets/pizzaking/mode-battle.svg");
    return {
      hotPizzaGradeImages: {
        1: require("../assets/hotpizza/grade-1.png"),
        2: require("../assets/hotpizza/grade-2.png"),
        3: require("../assets/hotpizza/grade-3.png"),
        4: require("../assets/hotpizza/grade-4.png"),
        5: require("../assets/hotpizza/grade-5.png"),
        6: require("../assets/hotpizza/grade-6.png"),
        7: require("../assets/hotpizza/grade-7.png"),
      },
      defaultFreeDropImage: require("../assets/hotpizza/hp-gloves.png"),
      defaultDropImage: require("../assets/hotpizza/hp-awp-blue.png"),
      defaultAvatar: require("../assets/img/jiapeople.png"),
      specialKeyBalance: 0,
      liveDropImageCache: {
        "d1bdaa83241ce8311b6613968fc3c6ed.png": require("../assets/skin-cache/live-drop-d1bdaa83241ce8311b6613968fc3c6ed.png"),
        "6922845da41c09630cebf767914ebf68.png": require("../assets/skin-cache/live-drop-6922845da41c09630cebf767914ebf68.png"),
        "cf5a63a9314210d55fe7d17bbacc122a.png": require("../assets/skin-cache/live-drop-cf5a63a9314210d55fe7d17bbacc122a.png"),
        "82be34cbbe6f0e338cab89c759aa0660.png": require("../assets/skin-cache/live-drop-82be34cbbe6f0e338cab89c759aa0660.png"),
        "14516583e293f481db908b26a9b1189a.png": require("../assets/skin-cache/live-drop-14516583e293f481db908b26a9b1189a.png"),
        "500151533291eeff620a49cf6af2bab2.png": require("../assets/skin-cache/live-drop-500151533291eeff620a49cf6af2bab2.png"),
        "522880faca626c5a553bb54357f4ac6e.png": require("../assets/skin-cache/live-drop-522880faca626c5a553bb54357f4ac6e.png"),
      },
      promotions: [],
      liveDropTimer: null,
      siteInfoTimer: null,
      onlineCount: 0,
      soundEnabled: true,
      soundVolume: 50,
      liveDrops: [],
      unreadCount: 0,
      atPageTop: true,
      accountMenuVisible: false,
      supportPanelVisible: false,
      supportFeedback: [],
      supportForm: {
        category: "other",
        title: "",
        content: "",
        contact: "",
      },
      modes: [
        { key: "case", title: "打开箱子", path: "/zh", icon: iconOpenCase, available: true },
        { key: "cheese", title: "奶酪秘境", path: "/Cheese", icon: iconCheese, available: true },
        { key: "battle", title: "箱子战斗", path: "/zh/battles", badge: "敬请期待", icon: iconBattle, available: !OPENBOX_ONLY_LAUNCH },
      ],
    };
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.getUnreadCount();
        this.getSpecialKeys();
      } else {
        this.unreadCount = 0;
        this.specialKeyBalance = 0;
        this.accountMenuVisible = false;
        this.supportFeedback = [];
      }
    },
    $route() {
      if (this.loggedIn) {
        this.getUnreadCount();
      }
    },
  },
  mounted() {
    this.updatePageScroll();
    window.addEventListener("scroll", this.updatePageScroll, { passive: true });
    this.getPromotionSlots();
    this.restoreLiveDrops();
    this.getLiveDrops();
    this.getSiteInfo();
    const storedVolume = localStorage.getItem("pizzaking-sound-volume");
    const savedVolume = Number(storedVolume);
    this.soundVolume = storedVolume !== null && savedVolume >= 0 && savedVolume <= 100 ? savedVolume : 50;
    this.soundEnabled = localStorage.getItem("pizzaking-sound-enabled") !== "0" && this.soundVolume > 0;
    this.applySoundState();
    this.liveDropTimer = window.setInterval(this.getLiveDrops, 5000);
    this.siteInfoTimer = window.setInterval(this.getSiteInfo, 60000);
    this.$root.$on("notice-read", this.getUnreadCount);
    this.$root.$on("notice-refresh", this.getUnreadCount);
    this.$root.$on("sound-state-change", this.syncSoundState);
    this.$root.$on("live-drop-refresh", this.getLiveDrops);
    this.$root.$on("online-count-update", this.updateOnlineCount);
    Utils.$on("special-key", this.getSpecialKeys);
    document.addEventListener("play", this.applySoundToMedia, true);
    if (this.loggedIn) {
      this.getUnreadCount();
      this.getSpecialKeys();
    }
  },
  beforeDestroy() {
    window.clearInterval(this.liveDropTimer);
    window.clearInterval(this.siteInfoTimer);
    this.$root.$off("notice-read", this.getUnreadCount);
    this.$root.$off("notice-refresh", this.getUnreadCount);
    this.$root.$off("sound-state-change", this.syncSoundState);
    this.$root.$off("live-drop-refresh", this.getLiveDrops);
    this.$root.$off("online-count-update", this.updateOnlineCount);
    Utils.$off("special-key", this.getSpecialKeys);
    window.removeEventListener("scroll", this.updatePageScroll);
    document.removeEventListener("play", this.applySoundToMedia, true);
  },
  methods: {
    updateOnlineCount(value) {
      this.onlineCount = Number(value || 0);
    },
    restoreLiveDrops() {
      const savedDrops = localStorage.getItem("pizzaking-live-drops-v3");
      if (savedDrops) this.liveDrops = JSON.parse(savedDrops);
    },
    getSpecialKeys() {
      this.$axios.post("/index/special_key/myKeys", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.specialKeyBalance = (res.data.data || []).reduce((total, item) => total + Number(item.quantity || 0), 0);
        }
      });
    },
    openMode(mode) {
      if (!mode.available) {
        this.$message.info(mode.key === "battle" ? "箱子战斗敬请期待" : "该玩法暂未开放");
        return;
      }
      this.go(mode.path);
    },
    getPromotionSlots() {
      this.$axios.post("/index/Setting/promotionSlots").then((res) => {
        if (res.data.status == 1) {
          this.promotions = res.data.data || [];
        }
      });
    },
    updatePageScroll() {
      this.atPageTop = window.pageYOffset < 80;
    },
    togglePageScroll() {
      const atPageTop = window.pageYOffset < 80;
      this.atPageTop = atPageTop;
      window.scrollTo({ top: atPageTop ? document.documentElement.scrollHeight : 0, behavior: "smooth" });
    },
    getLiveDrops() {
      this.$axios
        .post("/index/Box/latelynew", this.$qs.stringify({ page: 1, pageSize: 12 }))
        .then((res) => {
          const list = res.data && res.data.status == 1 && res.data.data ? res.data.data.list : [];
          if (!list || !list.length) return;
          const latestDrops = list.map((item, index) => ({
            key: String(
              item.drop_id ||
                `${item.create_time || "drop"}-${item.player_name || "player"}-${item.skin_name || item.name || "skin"}-${item.box_id || 0}-${index}`
            ),
            name: item.skin_name || item.name || "饰品掉落",
            title: item.skin_name || item.name || "饰品掉落",
            img: this.normalizeDropImage(item.imageUrl || item.img),
            price: Number(item.price || 0).toFixed(2),
            boxId: Number(item.box_id || 0),
            boxName: item.box_name || "",
            playerName: item.player_name || "玩家",
            playerImg: this.normalizeAvatar(item.player_img),
            rarityColor: item.color || "#7648ee",
            rarityBackground: this.normalizeDropBackground(item.img) || this.hotPizzaGradeBackground(item.color),
            isStattrak: /StatTrak/i.test(item.skin_name || item.name || ""),
          }));
          const currentState = this.liveDrops
            .map((item) => `${item.key}|${item.rarityBackground || ""}`)
            .join(",");
          const latestState = latestDrops
            .map((item) => `${item.key}|${item.rarityBackground || ""}`)
            .join(",");
          if (currentState === latestState) return;
          this.liveDrops = latestDrops;
          localStorage.setItem("pizzaking-live-drops-v3", JSON.stringify(latestDrops));
        });
    },
    getSiteInfo() {
      this.$axios.post("/index/Login/logininfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.onlineCount = Number(res.data.data.online_num || 0);
        }
      });
    },
    normalizeDropImage(url) {
      const image = String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
      const fileName = image.split("?")[0].split("/").pop();
      return this.liveDropImageCache[fileName] || image || this.defaultDropImage;
    },
    normalizeDropBackground(url) {
      return String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
    },
    hotPizzaGradeBackground(color) {
      const gradeByColor = {
        "#F8F8FF": 1,
        "#B0C4DE": 2,
        "#87CEEB": 2,
        "#4169E1": 3,
        "#6495ED": 3,
        "#9370DB": 4,
        "#DA70D6": 4,
        "#FF1493": 5,
        "#FF69B4": 5,
        "#DC143C": 6,
        "#FF4500": 6,
        "#FFA500": 7,
        "#FFD700": 7,
      };
      return this.hotPizzaGradeImages[gradeByColor[String(color || "").toUpperCase()] || 1];
    },
    normalizeAvatar(url) {
      const image = String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
      return image || this.defaultAvatar;
    },
    replaceDropImage(event) {
      event.target.src = event.target.dataset.fallback;
    },
    replacePlayerImage(event) {
      event.target.src = event.target.dataset.fallback;
    },
    replaceAccountAvatar(event) {
      event.target.src = this.defaultAccountAvatar;
    },
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      if (this.soundEnabled && this.soundVolume === 0) {
        this.soundVolume = 54;
      }
      this.persistSoundSettings();
      this.applySoundState();
    },
    setSoundVolume(event) {
      this.soundVolume = Number(event.target.value);
      this.soundEnabled = this.soundVolume > 0;
      this.persistSoundSettings();
      this.applySoundState();
    },
    persistSoundSettings() {
      localStorage.setItem("pizzaking-sound-enabled", this.soundEnabled ? "1" : "0");
      localStorage.setItem("pizzaking-sound-volume", String(this.soundVolume));
      const preferences = JSON.parse(localStorage.getItem("pizzaking-notice-preferences") || "{}");
      preferences.sound = this.soundEnabled;
      localStorage.setItem("pizzaking-notice-preferences", JSON.stringify(preferences));
    },
    openAccountPath(path) {
      this.accountMenuVisible = false;
      this.go(path);
    },
    logout() {
      this.accountMenuVisible = false;
      this.$emit("logout");
    },
    applySoundState() {
      document.querySelectorAll("audio, video").forEach((media) => {
        media.muted = !this.soundEnabled;
        media.volume = this.soundVolume / 100;
      });
      this.$root.$emit("sound-state-change", this.soundEnabled);
    },
    applySoundToMedia(event) {
      const media = event.target;
      if (media && (media.tagName === "AUDIO" || media.tagName === "VIDEO")) {
        if (media.dataset.pkSoundUnlocking === "1") return;
        media.muted = !this.soundEnabled;
        media.volume = this.soundVolume / 100;
      }
    },
    syncSoundState(enabled) {
      if (this.soundEnabled === Boolean(enabled)) return;
      this.soundEnabled = Boolean(enabled);
      if (this.soundEnabled && this.soundVolume === 0) {
        this.soundVolume = 54;
      }
      document.querySelectorAll("audio, video").forEach((media) => {
        media.muted = !this.soundEnabled;
        media.volume = this.soundVolume / 100;
      });
    },
    openDrop(drop) {
      if (drop.boxId) {
        this.go(`/Openbox?box_id=${drop.boxId}`);
      }
    },
    openPromotion(item) {
      if (!item.target_url) return;
      if (/^https?:\/\//i.test(item.target_url)) {
        window.open(item.target_url, "_blank");
        return;
      }
      this.go(item.target_url);
    },
    goCooperation() {
      this.$router.push({ path: "/Doubt", query: { category: "cooperation" } });
    },
    toggleSupportPanel() {
      this.supportPanelVisible = !this.supportPanelVisible;
      if (this.supportPanelVisible && this.loggedIn) {
        this.getSupportFeedback();
      }
    },
    openSupportLogin() {
      this.supportPanelVisible = false;
      this.$store.commit("getLogin", true);
    },
    goSupportPage() {
      this.supportPanelVisible = false;
      this.go("/Doubt");
    },
    getSupportFeedback() {
      this.$axios.post("/index/System/myFeedback", this.$qs.stringify({ page: 1, pageSize: 3 })).then((res) => {
        if (res.data.status === 1) {
          this.supportFeedback = res.data.data.list || [];
        }
      });
    },
    submitQuickFeedback() {
      if (!this.supportForm.title) {
        this.$message.error("请填写问题标题");
        return;
      }
      if (!this.supportForm.content) {
        this.$message.error("请填写问题描述");
        return;
      }
      this.$axios.post("/index/System/submitFeedback", this.$qs.stringify(this.supportForm)).then((res) => {
        if (res.data.status !== 1) {
          this.$message.error(res.data.msg || "提交失败");
          return;
        }
        this.$message.success(res.data.msg || "反馈已提交");
        this.supportForm.title = "";
        this.supportForm.content = "";
        this.getSupportFeedback();
      });
    },
    go(path) {
      this.$router.push({ path });
    },
    getUnreadCount() {
      this.$axios
        .post("/index/System/unreadNoticeCount", this.$qs.stringify({}))
        .then((res) => {
          if (res.data.status == 1) {
            this.unreadCount = Number(res.data.data.unread || 0);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.pk-chrome {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  min-height: 100%;
  z-index: 50;
  pointer-events: none;
  color: #d9deea;
  background: transparent;
}

.pk-chrome-side {
  width: 250px;
  height: 100%;
  min-height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: auto;
  overflow: visible;
  background: #171822;
  border-right: 1px solid #272937;
}

.pk-chrome-top {
  height: 58px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pk-top-meta {
  display: flex;
  align-items: center;
  gap: 9px;
}

.pk-language,
.pk-online {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #aeb7c8;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.pk-online {
  color: #c7d1df;
}

.pk-online i {
  width: 6px;
  height: 6px;
  display: block;
  background: #42dc87;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(66, 220, 135, 0.78);
}

.pk-flag {
  width: 28px;
  height: 18px;
  display: block;
  background: #ff4052;
  position: relative;
}

.pk-flag::after {
  content: "";
  width: 4px;
  height: 4px;
  position: absolute;
  left: 7px;
  top: 5px;
  background: #ffd96a;
  border-radius: 50%;
}

.pk-balance {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f26943;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 18px;
  font-weight: 900;
}

.pk-balance b {
  width: 19px;
  height: 19px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff4dc;
  background: rgba(242, 105, 67, 0.22);
  border: 1px solid rgba(242, 105, 67, 0.46);
  border-radius: 50%;
  font-size: 16px;
  line-height: 1;
}

.pk-balance i,
.pk-live strong::after {
  width: 14px;
  height: 14px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-sound {
  width: 100%;
  height: 62px;
  padding: 5px 24px 4px;
  position: relative;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) 20px;
  grid-template-rows: 34px 18px;
  align-items: center;
  column-gap: 10px;
  color: inherit;
  background: transparent;
  border-top: 1px solid #242631;
  border-bottom: 1px solid #242631;
  box-sizing: border-box;
}

.pk-sound-toggle {
  width: 20px;
  height: 28px;
  padding: 0;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  grid-column: 1;
  grid-row: 1;
}

.pk-sound-toggle span,
.pk-sound-max {
  width: 0;
  height: 0;
  display: block;
  border-left: 8px solid #a8afbc;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.pk-sound-max {
  justify-self: end;
  grid-column: 3;
  grid-row: 1;
}

.pk-sound-range {
  width: 100%;
  height: 18px;
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  background: transparent;
  grid-column: 2;
  grid-row: 1;
}

.pk-sound-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 8px;
  border-radius: 10px;
  background: linear-gradient(
    90deg,
    #8c92a2 0 var(--pk-sound-volume),
    #484c5b var(--pk-sound-volume) 100%
  );
}

.pk-sound-range::-webkit-slider-thumb {
  width: 10px;
  height: 18px;
  margin-top: -5px;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid #d3d8e4;
  border-radius: 3px;
  background: #b8becd;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.42);
}

.pk-sound-range::-moz-range-track {
  height: 8px;
  border-radius: 10px;
  background: #484c5b;
}

.pk-sound-range::-moz-range-progress {
  height: 8px;
  border-radius: 10px;
  background: #8c92a2;
}

.pk-sound-range::-moz-range-thumb {
  width: 10px;
  height: 18px;
  border: 1px solid #d3d8e4;
  border-radius: 3px;
  background: #b8becd;
}

.pk-sound em {
  grid-column-start: 1;
  grid-column-end: 4;
  grid-row: 2;
  align-self: center;
  color: #8c95a8;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.pk-sound.muted .pk-sound-toggle span,
.pk-sound.muted .pk-sound-max {
  opacity: 0.32;
}

.pk-sound.muted .pk-sound-range {
  opacity: 0.58;
}

.pk-logo {
  width: 224px;
  min-height: 78px;
  margin: 20px 13px 8px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff7e6;
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: transform 0.2s ease;
  box-sizing: border-box;
}

.pk-logo img {
  width: 70px;
  height: 70px;
  object-fit: contain;
  filter: drop-shadow(0 8px 15px rgba(255, 132, 26, 0.28));
}

.pk-logo > span {
  display: flex;
  align-items: baseline;
  font-size: 24px;
  font-weight: 950;
  letter-spacing: -1px;
  transition: color 0.2s ease;
}

.pk-logo small {
  margin-left: 0;
  color: #ff9d2e;
  font-size: 12px;
  letter-spacing: 0.08em;
}

.pk-logo:hover {
  color: #ffd266;
  transform: translateY(-1px) scale(1.015);
}

@keyframes pkLogoFloat {
  0%,
  100% {
    transform: translateY(0) rotate(-1deg);
  }

  50% {
    transform: translateY(-5px) rotate(1deg);
  }
}

@media (prefers-reduced-motion: no-preference) {
  .pk-logo img {
    animation: pkLogoFloat 3.8s ease-in-out infinite;
  }
}

.pk-login-label {
  margin: 8px 20px 12px;
  color: #626c7b;
  font-size: 14px;
}

.pk-auth-main {
  width: calc(100% - 40px);
  height: 41px;
  margin: 0 20px 10px;
  color: #fff;
  background: #f26900;
  border: 0;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 900;
}

.pk-auth-actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 0 20px 24px;
}

.pk-auth-actions button {
  height: 36px;
  color: #a8afbc;
  background: #3b3e4d;
  border: 0;
  border-radius: 7px;
  font-size: 18px;
  font-weight: 900;
}

.pk-user-card {
  width: calc(100% - 40px);
  min-height: 108px;
  margin: 0 20px 20px;
  padding: 13px 15px;
  display: grid;
  gap: 8px;
  color: #f3f6fb;
  text-align: left;
  background: linear-gradient(180deg, #252836, #20222f);
  border: 1px solid #363c50;
  border-radius: 8px;
  font-weight: 900;
}

.pk-user-card strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-user-currencies {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.pk-user-card .pk-currency,
.pk-account-balances .pk-currency {
  min-width: 0;
  display: flex;
  align-items: center;
  color: #ffc247;
  background: rgba(12, 13, 21, 0.24);
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 5px;
}

.pk-user-card .pk-currency {
  height: 25px;
  padding: 0 7px;
  gap: 5px;
  font-size: 12px;
}

.pk-user-card .pk-currency i,
.pk-account-balances .pk-currency i {
  display: block;
  flex: 0 0 auto;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-user-card .pk-currency i {
  width: 14px;
  height: 14px;
}

.pk-user-card .pk-currency b,
.pk-account-balances .pk-currency b {
  min-width: 0;
  overflow: hidden;
  color: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-currency.wheat { color: #f7d66c; }
.pk-currency.cheese { color: #ffe08a; }
.pk-currency.key { color: #83ead3; }
.pk-currency.wheat i { background-image: url("../assets/pizzaking/wheat-token.svg") !important; }
.pk-currency.cheese i { background-image: url("../assets/pizzaking/cheese-token.svg") !important; }
.pk-currency.key i { background-image: url("../assets/pizzaking/special-key-token.svg") !important; }

.pk-account-popover {
  width: calc(100% - 32px);
  position: absolute;
  left: 16px;
  top: 180px;
  z-index: 8;
  overflow: hidden;
  color: #edf1fb;
  background:
    radial-gradient(circle at 18% 0, rgba(255, 145, 35, 0.18), transparent 34%),
    #242735;
  border: 1px solid rgba(255, 177, 62, 0.36);
  border-radius: 10px;
  box-shadow: 0 22px 46px rgba(0, 0, 0, 0.44);
}

.pk-account-popover header {
  min-height: 70px;
  padding: 14px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 24px;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.pk-account-avatar {
  width: 42px;
  height: 42px;
  overflow: hidden;
  background: linear-gradient(145deg, #ffe19b, #ff8a1f);
  border-radius: 50%;
}

.pk-account-avatar img { width: 100%; height: 100%; display: block; object-fit: cover; }

.pk-account-popover header span {
  display: block;
  color: #8490a5;
  font-size: 10px;
  font-weight: 1000;
  letter-spacing: 0.15em;
}

.pk-account-popover header strong {
  max-width: 132px;
  margin-top: 4px;
  display: block;
  overflow: hidden;
  color: #f4f6ff;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-account-popover header button {
  width: 24px;
  height: 24px;
  padding: 0;
  color: #aab3c4;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
}

.pk-account-balances {
  padding: 12px 14px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.pk-account-balances .pk-currency {
  height: 34px;
  padding: 0 9px;
  gap: 7px;
  font-size: 12px;
}

.pk-account-balances .pk-currency i {
  width: 17px;
  height: 17px;
}

.pk-account-balances .pk-currency b {
  font-weight: 1000;
}

.pk-account-actions {
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.pk-account-actions button,
.pk-account-logout {
  min-height: 34px;
  padding: 0 7px;
  color: #cbd2e1;
  background: #2b2e3e;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 900;
}

.pk-account-actions button:hover {
  color: #161721;
  background: linear-gradient(180deg, #ffd159, #ff831b);
}

.pk-account-logout {
  width: calc(100% - 16px);
  margin: 0 8px 8px;
  color: #ffb6b6;
  background: rgba(244, 82, 82, 0.08);
  border-color: rgba(244, 82, 82, 0.16);
}

.pk-side-link {
  box-sizing: border-box;
  width: calc(100% - 28px);
  height: 48px;
  margin: 0 14px 8px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  color: #8b96a8;
  background: #252834;
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 800;
  white-space: nowrap;
}

.pk-notice-link {
  box-sizing: border-box;
  width: calc(100% - 28px);
  height: 42px;
  margin: -8px 14px 12px;
  padding: 0 16px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #ffd28c;
  background: linear-gradient(180deg, rgba(53, 47, 51, 0.95), rgba(36, 39, 52, 0.95));
  border: 1px solid rgba(255, 138, 31, 0.28);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 900;
}

.pk-notice-link i {
  width: 20px;
  height: 20px;
  display: block;
  border: 0;
  background: #ff9d24;
  -webkit-mask: url("../assets/pizzaking/icon-notice.svg") center / contain no-repeat;
  mask: url("../assets/pizzaking/icon-notice.svg") center / contain no-repeat;
}

.pk-notice-link em {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  position: absolute;
  right: 10px;
  top: -8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #151620;
  background: linear-gradient(180deg, #ffdc4c, #ff8a00);
  border-radius: 999px;
  font-size: 11px;
  font-style: normal;
  box-shadow: 0 8px 18px rgba(255, 138, 0, 0.28);
}

.pk-side-link i {
  box-sizing: border-box;
  width: 20px;
  min-width: 20px;
  height: 15px;
  display: block;
  border: 2px solid #8b96a8;
  border-radius: 2px;
}

.pk-side-link:hover {
  color: #eef2ff;
  background: #2b2f3e;
}

.pk-side-link.pk-link-spread { color: #b7d3ff; }
.pk-side-link.pk-link-wheel { color: #ffba42; }
.pk-side-link.pk-link-freecase { color: #9ce981; }
.pk-side-link.pk-link-roll { color: #c99dff; }
.pk-side-link.pk-link-mall { color: #f4ca74; }
.pk-side-link.pk-link-ouhuang { color: #ffd359; }
.pk-side-link.pk-link-promotion { color: #5edaf4; }
.pk-side-link.pk-task-link { color: #a8d76f; }
.pk-side-link.pk-link-cooperation { color: #f3ae7d; }
.pk-side-link.pk-link-notice { color: #b9c5d8; }
.pk-side-link.pk-support-link { color: #b7d3ff; }

.pk-link-spread i,
.pk-link-wheel i,
.pk-link-freecase i,
.pk-link-roll i,
.pk-link-mall i,
.pk-link-ouhuang i,
.pk-link-promotion i,
.pk-task-link i,
.pk-link-cooperation i,
.pk-link-notice i,
.pk-support-link i {
  width: 21px;
  height: 21px;
  border: 0;
  border-radius: 0;
  background: currentColor;
  -webkit-mask: center / contain no-repeat;
  mask: center / contain no-repeat;
}

.pk-link-spread i { -webkit-mask-image: url("../assets/pizzaking/icon-partner.svg"); mask-image: url("../assets/pizzaking/icon-partner.svg"); }
.pk-link-wheel i { -webkit-mask-image: url("../assets/pizzaking/icon-wheel.svg"); mask-image: url("../assets/pizzaking/icon-wheel.svg"); }
.pk-link-freecase i { -webkit-mask-image: url("../assets/pizzaking/icon-welfare.svg"); mask-image: url("../assets/pizzaking/icon-welfare.svg"); }
.pk-link-roll i { -webkit-mask-image: url("../assets/pizzaking/icon-battle.svg"); mask-image: url("../assets/pizzaking/icon-battle.svg"); }
.pk-link-mall i { -webkit-mask-image: url("../assets/pizzaking/icon-wheat-mall.svg"); mask-image: url("../assets/pizzaking/icon-wheat-mall.svg"); }
.pk-link-ouhuang i { -webkit-mask-image: url("../assets/pizzaking/icon-champion.svg"); mask-image: url("../assets/pizzaking/icon-champion.svg"); }
.pk-link-promotion i { -webkit-mask-image: url("../assets/pizzaking/icon-activity-center.svg"); mask-image: url("../assets/pizzaking/icon-activity-center.svg"); }
.pk-task-link i { -webkit-mask-image: url("../assets/pizzaking/icon-task-center.svg"); mask-image: url("../assets/pizzaking/icon-task-center.svg"); }
.pk-link-cooperation i { -webkit-mask-image: url("../assets/pizzaking/icon-customer-service.svg"); mask-image: url("../assets/pizzaking/icon-customer-service.svg"); }
.pk-link-notice i { -webkit-mask-image: url("../assets/pizzaking/icon-notice.svg"); mask-image: url("../assets/pizzaking/icon-notice.svg"); }
.pk-support-link i { -webkit-mask-image: url("../assets/pizzaking/icon-feedback.svg"); mask-image: url("../assets/pizzaking/icon-feedback.svg"); }

.pk-chrome-main {
  position: absolute;
  left: 250px;
  right: 0;
  top: 115px;
  height: 82px;
  pointer-events: auto;
}

.pk-live {
  height: 115px;
  position: absolute;
  left: 250px;
  right: 0;
  top: 0;
  z-index: 2;
  pointer-events: auto;
  background: #161721;
  border-bottom: 1px solid #2c2e3e;
  overflow: hidden;
}

.pk-live-track {
  width: 100%;
  min-width: max-content;
  height: 100%;
  display: flex;
}

.pk-live-drop-enter-active,
.pk-live-drop-leave-active,
.pk-live-drop-move {
  transition: transform 0.46s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease;
}

.pk-live-drop-enter {
  opacity: 0;
  transform: translateX(-130px);
}

.pk-live-drop-leave-active {
  position: absolute;
}

.pk-live-drop-leave-to {
  opacity: 0;
  transform: translateX(130px);
}

.pk-live-item {
  width: 130px;
  min-width: 130px;
  flex: 1 0 130px;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: inherit;
  font: inherit;
  background: transparent;
  border: 0;
  border-left: 1px solid #292b3a;
  overflow: visible;
  isolation: isolate;
}

.pk-live-item-link {
  cursor: pointer;
}

.pk-live-item::before {
  content: "";
  width: 80px;
  height: 80px;
  position: absolute;
  top: 5px;
  background: radial-gradient(circle, var(--pk-drop-color, #7f49ff), transparent 72%);
  border-radius: 50%;
  filter: blur(1px);
  z-index: 0;
  pointer-events: none;
}

.pk-live-item::after {
  content: "";
  width: 42px;
  height: 2px;
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--pk-drop-color, #7f49ff);
  box-shadow: 0 0 12px var(--pk-drop-color, #7f49ff);
  opacity: 0.8;
  z-index: 0;
  pointer-events: none;
}

.pk-live-item img {
  width: 90px;
  height: 90px;
  position: relative;
  margin-top: 0;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 10px 14px rgba(0, 0, 0, 0.48));
  z-index: 1;
}

.pk-live strong {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #edb145;
  font-size: 13px;
  font-weight: 900;
  line-height: 16px;
  z-index: 2;
}

.pk-live strong::after {
  content: "";
  margin-left: 3px;
  vertical-align: -2px;
}

.pk-live-stattrak {
  width: 13px;
  height: 13px;
  position: absolute;
  z-index: 2;
  top: 8px;
  right: 14px;
  display: grid;
  place-items: center;
  color: #ff9d2f;
  font-size: 13px;
  line-height: 1;
  text-shadow: 0 0 8px rgba(255, 137, 21, 0.86);
}

.pk-live-tooltip {
  width: 130px;
  min-height: 150px;
  padding: 9px 7px 55px;
  position: absolute;
  z-index: 20;
  top: 115px;
  left: 50%;
  display: none;
  align-items: center;
  flex-direction: column;
  gap: 6px;
  transform: translateX(-50%);
  color: #dfe4ef;
  text-align: center;
  white-space: normal;
  background: #232531;
  border: 0;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.36);
}

.pk-live-tooltip::before {
  content: "";
  width: 76px;
  height: 76px;
  position: absolute;
  top: 17px;
  left: 50%;
  border-radius: 50%;
  background: radial-gradient(circle, var(--pk-drop-color, #7648ee), transparent 72%);
  opacity: 0.22;
  transform: translateX(-50%);
}

.pk-live-tooltip > img {
  width: 35px;
  height: 35px;
  position: absolute;
  bottom: 19px;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  object-fit: cover;
  border: 0;
  border-radius: 5px;
  background: #2b2e3d;
}

.pk-live-tooltip > span {
  width: 100%;
  min-width: 0;
  display: grid;
  gap: 3px;
}

.pk-live-tooltip b,
.pk-live-tooltip em,
.pk-live-tooltip i,
.pk-live-tooltip small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-live-tooltip b {
  color: #fff;
  font-size: 11px;
  font-weight: 900;
}

.pk-live-tooltip em {
  position: absolute;
  right: 5px;
  bottom: 4px;
  left: 5px;
  color: #d2d2d2;
  font-size: 12px;
  font-style: normal;
}

.pk-live-tooltip small {
  color: #b2bbc1;
  font-size: 11px;
}

.pk-live-tooltip i {
  color: #ffc04b;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.pk-live-tooltip-price {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.pk-live-tooltip-price .pk-live-pizza-icon {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-live:has(.pk-live-item:hover) {
  overflow: visible;
  clip-path: inset(0 0 -300px 0);
}

.pk-live-item:hover .pk-live-tooltip {
  display: flex;
}

.pk-modes {
  height: 84px;
  display: grid;
  grid-template-columns: repeat(9, minmax(90px, 1fr));
  gap: 6px;
  padding-left: 12px;
  background: #20222f;
}

.pk-modes button {
  height: 73px;
  align-self: end;
  position: relative;
  color: #14d6e6;
  background: #252836;
  border: 0;
  border-radius: 0 0 8px 8px;
  font-weight: 900;
}

.pk-modes button.active {
  color: #ff8a27;
  border-bottom: 3px solid #ff8a27;
}

.pk-modes button.mode-battle { color: #8f67ff; background: #2d2a58; }
.pk-modes button.mode-cheese { color: #ffd45d; background: #3a3021; }

.pk-modes span {
  width: 28px;
  height: 28px;
  margin: 0 auto 7px;
  display: block;
  background: currentColor;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
}

.pk-modes em {
  position: absolute;
  right: 8px;
  top: 0;
  padding: 3px 9px;
  color: #42d7ff;
  background: #155270;
  font-size: 10px;
  font-style: normal;
}

.pk-modes b {
  display: block;
  font-size: 12px;
}

.pk-login-label {
  font-size: 0 !important;
}

.pk-login-label::before {
  content: "账号";
  font-size: 14px;
}

.pk-free-drop {
  width: 210px;
  height: 105px;
  margin: 18px 20px 10px;
  position: relative;
  overflow: hidden;
  color: #fff;
  background: linear-gradient(180deg, rgba(48, 38, 43, 0.95), rgba(32, 35, 47, 0.95));
  border: 1px solid rgba(232, 132, 74, 0.45);
  border-radius: 8px;
}

.pk-free-drop-money {
  position: absolute;
  left: 10px;
  top: 8px;
  color: #edb145;
  font-size: 13px;
  font-weight: 900;
}

.pk-free-drop-time {
  position: absolute;
  left: 10px;
  bottom: 8px;
  color: #ffeeda;
  font-size: 10px;
  font-weight: 800;
}

.pk-free-drop-time span {
  color: #cc8c3d;
}

.pk-free-drop img {
  width: 86px;
  height: 70px;
  position: absolute;
  left: 16px;
  top: 24px;
  object-fit: contain;
}

.pk-free-drop strong,
.pk-free-drop em {
  position: absolute;
  left: 116px;
  right: 8px;
  overflow: hidden;
  color: #fff;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-free-drop strong {
  top: 25px;
  font-size: 11px;
}

.pk-free-drop em {
  top: 42px;
  color: #bfc7d4;
  font-size: 11px;
  font-style: normal;
}

.pk-free-drop button {
  width: 51px;
  height: 26px;
  position: absolute;
  left: 134px;
  top: 65px;
  color: #fff;
  background: linear-gradient(360deg, #b44652, #e8844a);
  border: 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 900;
}

.pk-bonus-ad {
  box-sizing: border-box;
  width: 222px;
  height: 238px;
  margin: 16px 14px 0;
  padding: 18px 12px;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 62% 55%, rgba(255, 100, 0, 0.46), transparent 34%),
    linear-gradient(180deg, #3a2023, #d64228 70%, #2a1417);
  border-radius: 8px;
  color: #fff;
  box-shadow: 0 18px 28px rgba(0, 0, 0, 0.34);
}

.pk-bonus-ad b,
.pk-bonus-ad span {
  display: block;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.05;
}

.pk-bonus-ad span {
  color: #ffe8c5;
}

.pk-bonus-ad button {
  width: 190px;
  height: 28px;
  position: absolute;
  left: 16px;
  bottom: 12px;
  color: #fff;
  background: linear-gradient(180deg, #ffb031, #f16500);
  border: 0;
  border-radius: 4px;
  font-weight: 900;
}

/* HotPizza 2026 visual pass: shared shell geometry and first-screen chrome. */
.pk-chrome {
  --pk-side-width: 236px;
  --pk-live-height: 116px;
  --pk-nav-height: 86px;
  --pk-line: rgba(56, 59, 78, 0.92);
  color: #d8deea;
}

.pk-chrome-side {
  width: var(--pk-side-width);
  background:
    linear-gradient(180deg, rgba(24, 25, 36, 0.98), rgba(19, 20, 29, 0.99)),
    radial-gradient(circle at 50% 0, rgba(255, 132, 24, 0.08), transparent 34%);
  border-right: 1px solid #2a2d3c;
  box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.018);
}

.pk-chrome-top {
  height: 54px;
  padding: 0 18px;
}

.pk-logo {
  width: 205px;
  margin: 18px auto 10px;
  filter: drop-shadow(0 12px 22px rgba(255, 103, 0, 0.16));
}

.pk-auth-main,
.pk-user-card {
  width: calc(100% - 32px);
  margin-left: 16px;
  margin-right: 16px;
}

.pk-auth-actions {
  padding-left: 16px;
  padding-right: 16px;
  gap: 8px;
}

.pk-side-link,
.pk-notice-link {
  width: calc(100% - 24px);
  margin-left: 12px;
  margin-right: 12px;
  border-radius: 6px;
  background: linear-gradient(180deg, #262935, #222531);
}

.pk-free-drop {
  width: calc(100% - 28px);
  margin: 16px 14px 10px;
}

.pk-bonus-ad {
  width: calc(100% - 24px);
  height: 214px;
  margin: 14px 12px 0;
}

.pk-live {
  left: var(--pk-side-width);
  height: var(--pk-live-height);
  background:
    linear-gradient(180deg, #151722, #171924),
    radial-gradient(circle at 40% 0, rgba(88, 58, 190, 0.14), transparent 38%);
  border-bottom: 1px solid var(--pk-line);
}

.pk-live-item {
  width: 162px;
  flex-basis: 162px;
  border-left: 1px solid #2a2d3c;
  background: linear-gradient(180deg, rgba(18, 20, 30, 0.35), rgba(20, 22, 31, 0.15));
}

.pk-live-item::before {
  width: 118px;
  height: 96px;
  top: 2px;
  background: radial-gradient(circle, rgba(116, 70, 255, 0.74), rgba(90, 55, 190, 0.34) 42%, transparent 72%);
  filter: blur(2px);
}

.pk-live-item img {
  width: 118px;
  height: 88px;
  margin-top: 0;
}

.pk-live strong {
  bottom: 8px;
  font-size: 15px;
  color: #ffc04b;
  text-shadow: 0 2px 7px rgba(0, 0, 0, 0.42);
}

.pk-chrome-main {
  left: var(--pk-side-width);
  top: var(--pk-live-height);
  height: var(--pk-nav-height);
}

.pk-modes {
  height: var(--pk-nav-height);
  grid-template-columns: repeat(9, minmax(114px, 1fr));
  gap: 7px;
  padding: 0 12px;
  background: #202331;
  border-bottom: 1px solid #2b2e3d;
}

.pk-modes button {
  height: 74px;
  border-radius: 0 0 8px 8px;
  background: #252836;
  transition: filter 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.pk-modes button:hover {
  filter: brightness(1.1);
  transform: translateY(-1px);
}

.pk-modes button.active {
  border-bottom-width: 4px;
  box-shadow: inset 0 -20px 28px rgba(255, 131, 0, 0.12);
}

.pk-modes span {
  width: 30px;
  height: 30px;
  filter: drop-shadow(0 0 8px currentColor);
}

.pk-modes b {
  font-size: 13px;
  line-height: 16px;
}

@media (max-width: 980px) {
  .pk-chrome {
    --pk-side-width: 0px;
  }

  .pk-chrome-side {
    display: none;
  }

  .pk-live,
  .pk-chrome-main {
    left: 0;
  }
}

.pk-scroll-toggle {
  width: calc(100% - 24px);
  height: 38px;
  margin: 14px 12px 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #e9dcc3;
  background: #222531;
  border: 1px solid #3a3e50;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 900;
}

.pk-scroll-toggle:hover {
  color: #fff1d2;
  border-color: rgba(255, 189, 66, 0.58);
}

.pk-scroll-toggle i {
  width: 9px;
  height: 9px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg) translateY(-2px);
}

.pk-scroll-toggle i.up {
  transform: rotate(225deg) translateY(-2px);
}

.pk-support-float {
  width: 122px;
  height: 46px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: fixed;
  z-index: 72;
  right: 22px;
  bottom: 24px;
  pointer-events: auto;
  color: #fff1d2;
  border: 1px solid rgba(255, 189, 66, 0.58);
  border-radius: 23px;
  background: linear-gradient(145deg, rgba(45, 39, 48, 0.96), rgba(28, 30, 42, 0.98));
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.34), 0 0 24px rgba(255, 141, 31, 0.14);
  font-family: inherit;
  font-size: 13px;
  font-weight: 1000;
  cursor: pointer;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.pk-support-float:hover {
  border-color: #ffbd42;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.38), 0 0 30px rgba(255, 141, 31, 0.24);
  transform: translateY(-2px);
}

.pk-support-float i {
  width: 16px;
  height: 13px;
  position: relative;
  border: 2px solid #ffbd42;
  border-radius: 5px;
}

.pk-support-float i::after {
  content: "";
  width: 5px;
  height: 5px;
  position: absolute;
  left: 1px;
  bottom: -5px;
  border-left: 2px solid #ffbd42;
  border-bottom: 2px solid #ffbd42;
  transform: skewY(-36deg);
}

.pk-support-float em {
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  display: grid;
  place-items: center;
  position: absolute;
  top: -7px;
  right: -4px;
  color: #fff;
  border-radius: 10px;
  background: #e54b42;
  font-size: 10px;
  font-style: normal;
  line-height: 1;
}

.pk-support-panel {
  width: 330px;
  max-height: min(520px, calc(100vh - 96px));
  padding: 16px;
  position: fixed;
  right: 22px;
  bottom: 82px;
  z-index: 72;
  pointer-events: auto;
  overflow-y: auto;
  color: #eef2fb;
  background:
    radial-gradient(circle at 92% 0, rgba(255, 145, 31, 0.2), transparent 36%),
    linear-gradient(150deg, #292b3a, #1b1d28);
  border: 1px solid rgba(255, 188, 76, 0.48);
  border-radius: 12px;
  box-shadow: 0 22px 52px rgba(0, 0, 0, 0.48), 0 0 28px rgba(255, 134, 31, 0.12);
}

.pk-support-panel header {
  margin-bottom: 14px;
  padding-bottom: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.09);
}

.pk-support-panel header span,
.pk-support-panel header strong {
  display: block;
}

.pk-support-panel header span {
  color: #f7a741;
  font-size: 10px;
  font-weight: 1000;
  letter-spacing: 0.16em;
}

.pk-support-panel header strong {
  margin-top: 4px;
  font-size: 16px;
}

.pk-support-panel header button {
  width: 26px;
  height: 26px;
  padding: 0;
  color: #b9c0cf;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
}

.pk-support-panel > p,
.pk-support-empty {
  margin: 0 0 13px;
  color: #9fa9bb;
  font-size: 13px;
  line-height: 1.6;
}

.pk-support-login,
.pk-support-submit,
.pk-support-detail {
  min-height: 38px;
  padding: 0 13px;
  color: #fff4dd;
  border: 1px solid rgba(255, 190, 81, 0.52);
  border-radius: 6px;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 900;
}

.pk-support-login,
.pk-support-submit {
  background: linear-gradient(180deg, #ff9a23, #df5a00);
}

.pk-support-login {
  width: 100%;
}

.pk-support-history {
  max-height: 138px;
  margin-bottom: 12px;
  display: grid;
  gap: 7px;
  overflow-y: auto;
}

.pk-support-history article {
  padding: 9px 10px;
  background: rgba(13, 15, 23, 0.42);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 7px;
}

.pk-support-history strong {
  max-width: 204px;
  display: inline-block;
  overflow: hidden;
  color: #e7ebf6;
  font-size: 12px;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}

.pk-support-history span {
  float: right;
  color: #ffc357;
  font-size: 11px;
  font-weight: 900;
}

.pk-support-history p {
  margin: 6px 0 0;
  color: #9ea9bb;
  font-size: 12px;
  line-height: 1.45;
}

.pk-support-panel input,
.pk-support-panel textarea {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 9px;
  padding: 10px 11px;
  color: #e9edf7;
  outline: 0;
  background: #1c1e2a;
  border: 1px solid #3b4051;
  border-radius: 6px;
  font: inherit;
  font-size: 13px;
}

.pk-support-panel textarea {
  min-height: 78px;
  resize: vertical;
}

.pk-support-panel input:focus,
.pk-support-panel textarea:focus {
  border-color: rgba(255, 174, 61, 0.82);
}

.pk-support-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.pk-support-detail {
  color: #c8cfdd;
  background: #303443;
  border-color: #454b5e;
}

@media (max-width: 520px) {
  .pk-support-panel {
    width: calc(100vw - 28px);
    right: 14px;
    bottom: 74px;
  }

  .pk-support-float {
    right: 14px;
    bottom: 16px;
  }
}

/* HotPizza exact-pass: restore measured public shell dimensions. */
.pk-chrome {
  --pk-side-width: 250px;
  --pk-live-height: 115px;
  --pk-nav-height: 80px;
}

.pk-chrome-side {
  width: 250px;
  background: #171923;
  border-right-color: #2a2d3b;
}

.pk-chrome-top {
  height: 58px;
}

.pk-logo {
  width: 224px;
  margin: 20px 13px 8px;
}

.pk-live {
  left: 250px;
  height: 115px;
  background: #151620;
  border-bottom: 1px solid #2b2d3c;
}

.pk-live-item {
  width: 130px;
  flex-basis: 130px;
  background: #151620;
  border-left: 1px solid #292b3a;
}

.pk-live-item::before {
  width: 86px;
  height: 86px;
  top: 4px;
  background: radial-gradient(circle, var(--pk-drop-color, #713df6), transparent 72%);
  filter: blur(2px);
}

.pk-live-item.has-rarity-background::before {
  width: 112px;
  height: 100px;
  top: 0;
  background: var(--pk-drop-background) center / contain no-repeat;
  border-radius: 0;
  filter: none;
  opacity: 0.9;
}

.pk-live-item img {
  width: 90px;
  height: 90px;
}

.pk-live strong {
  bottom: 8px;
  font-size: 14px;
  color: #ffc04b;
}

.pk-chrome-main {
  left: 250px;
  top: 115px;
  height: 80px;
}

.pk-modes {
  height: 80px;
  grid-template-columns: repeat(9, minmax(108px, 1fr));
  gap: 6px;
  padding: 0 12px;
  background: #20222f;
}

.pk-modes button {
  height: 73px;
  border-radius: 0 0 8px 8px;
}

.pk-modes button.unavailable {
  opacity: 0.52;
  cursor: not-allowed;
  filter: saturate(0.35);
}

.pk-modes button.unavailable em {
  right: 5px;
  padding: 3px 5px;
  color: #aeb5c5;
  background: #343746;
}

@media (max-width: 980px) {
  .pk-chrome {
    --pk-side-width: 0px;
  }

  .pk-chrome-side {
    display: none;
  }

  .pk-live,
  .pk-chrome-main {
    left: 0;
  }
}

.pk-mobile-battle-link,
.pk-mobile-nav {
  display: none;
}

/* HotPizza mobile shell: the desktop rail becomes a full-width account/menu block. */
@media (max-width: 600px) {
  .pk-chrome {
    width: 100%;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    background: #1c1d29;
  }

  .pk-live {
    width: 100%;
    height: 115px;
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    order: 1;
  }

  .pk-live-item {
    width: 130px;
    flex-basis: 130px;
  }

  .pk-live-tooltip {
    display: none !important;
  }

  .pk-chrome-side {
    width: 100%;
    height: auto;
    min-height: 0;
    position: relative;
    left: auto;
    top: auto;
    order: 2;
    display: flex;
    flex-direction: column;
    overflow: visible;
    background: #1c1d29;
    border-right: 0;
    border-bottom: 1px solid #292c39;
  }

  .pk-chrome-top {
    order: 1;
    height: 58px;
    padding: 0 28px;
    border-bottom: 1px solid #282a37;
  }

  .pk-language {
    font-size: 0;
  }

  .pk-language::after {
    content: "";
    width: 0;
    height: 0;
    margin-left: 9px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #5e6472;
  }

  .pk-top-meta {
    width: 100%;
    justify-content: space-between;
  }

  .pk-online {
    display: inline-flex;
    color: #f2763d;
    font-size: 16px;
    font-weight: 1000;
  }

  .pk-online i {
    width: 12px;
    height: 9px;
    position: relative;
    background: transparent;
    border: 2px solid #f2763d;
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-radius: 50%;
    box-shadow: none;
    transform: rotate(-45deg);
  }

  .pk-balance {
    display: none;
  }

  .pk-sound {
    order: 2;
    height: 58px;
    padding: 4px 28px;
    grid-template-columns: 16px minmax(0, 1fr) 16px;
    grid-template-rows: 34px 16px;
    column-gap: 9px;
    border-top: 0;
  }

  .pk-sound-toggle span,
  .pk-sound-max {
    width: 7px;
    height: 9px;
    position: relative;
    border: 0;
    background: #a8afbc;
  }

  .pk-sound-toggle span::before,
  .pk-sound-max::before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    left: -6px;
    top: -2px;
    border-right: 7px solid #a8afbc;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
  }

  .pk-sound-toggle span::after {
    content: "×";
    position: absolute;
    left: 8px;
    top: -6px;
    color: #6e7585;
    font-size: 12px;
    line-height: 1;
  }

  .pk-sound-max::after {
    content: "))";
    position: absolute;
    left: 8px;
    top: -5px;
    color: #a8afbc;
    font-size: 11px;
    line-height: 1;
  }

  .pk-sound em {
    display: none;
  }

  .pk-logo {
    display: none;
  }

  .pk-mobile-battle-link,
  .pk-side-link,
  .pk-notice-link {
    width: calc(100% - 20px);
    height: 33px;
    min-height: 33px;
    margin: 10px 10px 0;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #fff;
    border: 0;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 1000;
    text-align: center;
  }

  .pk-mobile-battle-link {
    order: 4;
    position: relative;
    background: linear-gradient(180deg, #765de0, #433392);
    box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.16);
  }

  .pk-mobile-battle-link span {
    width: 22px;
    height: 22px;
    display: block;
    background: #fff;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
  }

  .pk-mobile-battle-link em {
    padding: 2px 5px;
    position: absolute;
    right: 9px;
    top: 7px;
    color: #e7e1ff;
    background: rgba(21, 16, 56, 0.5);
    border-radius: 3px;
    font-size: 9px;
    font-style: normal;
  }

  .pk-link-spread {
    order: 3;
    background: linear-gradient(180deg, #ff7447, #cb1c2f);
  }

  .pk-link-freecase {
    order: 5;
    background: linear-gradient(180deg, #ff9a2e, #ce5900);
  }

  .pk-link-mall {
    order: 6;
    background: linear-gradient(180deg, #31c466, #157a3b);
  }

  .pk-link-ouhuang {
    order: 12;
    color: #aeb6c8;
    background: #252834;
    justify-content: flex-start;
  }

  .pk-login-label {
    order: 8;
    margin: 26px 20px 12px;
    color: #626c7b;
  }

  .pk-auth-main,
  .pk-user-card {
    order: 9;
    width: calc(100% - 60px);
    min-height: 42px;
    margin: 8px 30px 0;
  }

  .pk-auth-actions {
    order: 10;
    width: 100%;
    padding: 10px 30px 14px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    box-sizing: border-box;
  }

  .pk-auth-actions button {
    width: 100%;
    min-width: 0;
    margin: 0;
  }

  .pk-account-popover {
    order: 10;
    width: calc(100% - 28px);
    margin: 10px 14px 0;
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    box-sizing: border-box;
  }

  .pk-notice-link {
    order: 11;
    background: linear-gradient(180deg, #34384a, #292d3b);
  }

  .pk-link-promotion,
  .pk-link-ouhuang,
  .pk-task-link,
  .pk-link-cooperation,
  .pk-link-notice,
  .pk-support-link {
    order: 12;
    color: #aeb6c8;
    background: #252834;
    justify-content: flex-start;
  }

  .pk-free-drop {
    order: 13;
    width: calc(100% - 28px);
    margin: 20px 14px 8px;
  }

  .pk-bonus-ad {
    order: 14;
    width: calc(100% - 28px);
    margin: 14px 14px 20px;
  }

  .pk-scroll-toggle {
    display: none;
  }

  .pk-chrome-main {
    display: none;
  }

  .pk-mobile-nav {
    height: 75px;
    padding: 7px 10px 6px;
    position: fixed;
    z-index: 80;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: rgba(21, 22, 32, 0.96);
    border-top: 1px solid rgba(255, 255, 255, 0.055);
    backdrop-filter: blur(8px);
    box-sizing: border-box;
  }

  .pk-mobile-nav button {
    width: 58px;
    height: 58px;
    padding: 0;
    position: relative;
    display: grid;
    place-items: center;
    color: #c8ceda;
    background: linear-gradient(180deg, #303442, #252834);
    border: 0;
    border-radius: 10px;
  }

  .pk-mobile-nav button.active:first-child {
    color: #ffb64c;
    background: linear-gradient(180deg, rgba(241, 179, 89, 0.48), rgba(241, 179, 89, 0.12));
  }

  .pk-mobile-nav button.battle {
    color: #a789ff;
    background: linear-gradient(180deg, rgba(136, 98, 244, 0.48), rgba(136, 98, 244, 0.12));
  }

  .pk-mobile-nav button.cheese {
    color: #ffd45d;
    background: linear-gradient(180deg, rgba(198, 150, 47, 0.48), rgba(110, 75, 15, 0.18));
  }

  .pk-mobile-nav button.inventory {
    color: #ef7452;
    background: linear-gradient(180deg, rgba(255, 77, 39, 0.4), rgba(239, 116, 82, 0.12));
  }

  .pk-mobile-nav button::after {
    content: "";
    height: 3px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 10px;
    background: currentColor;
    opacity: 0.92;
  }

  .pk-mobile-nav button > span {
    width: 28px;
    height: 28px;
    display: block;
    background: currentColor;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
  }

  .pk-mobile-nav button.inventory > span {
    width: 24px;
    height: 18px;
    background: transparent;
    border: 2px solid currentColor;
    border-radius: 3px;
    box-sizing: border-box;
  }

  .pk-mobile-nav button.inventory > span::before {
    content: "";
    width: 10px;
    height: 4px;
    position: absolute;
    left: 50%;
    top: 17px;
    transform: translateX(-50%);
    border: 2px solid currentColor;
    border-bottom: 0;
    border-radius: 3px 3px 0 0;
  }

  .pk-mobile-nav em {
    padding: 2px 3px;
    position: absolute;
    right: 2px;
    top: 2px;
    color: #dcd3ff;
    background: rgba(31, 24, 67, 0.8);
    border-radius: 3px;
    font-size: 7px;
    font-style: normal;
    line-height: 1;
  }

  .pk-support-float {
    display: none;
  }

  .pk-support-panel {
    right: 12px;
    bottom: 139px;
  }
}

@media (min-width: 981px) {
  .pk-scroll-toggle {
    width: 226px;
    height: 40px;
    margin: 0;
    position: fixed;
    left: 12px;
    bottom: 20px;
    z-index: 74;
    background: rgba(34, 37, 49, 0.96);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.34);
    backdrop-filter: blur(8px);
  }
}
</style>

<style lang="less">
/* 2026-09-24: use the HotPizza rarity artwork behind live-drop items. */
.pk-live-item.has-rarity-background::before {
  width: 104px !important;
  height: 104px !important;
  left: 50% !important;
  top: -2px !important;
  z-index: 0 !important;
  opacity: 0.86 !important;
  transform: translateX(-50%) !important;
  background: var(--pk-drop-background) center / contain no-repeat !important;
  border-radius: 0 !important;
  filter: none !important;
}

.pk-live-item > img {
  z-index: 1 !important;
  mix-blend-mode: normal !important;
}

.pk-live-item > strong,
.pk-live-item > .pk-live-stattrak {
  z-index: 2 !important;
}
</style>

<style lang="less">
/* 2026-10-01 mobile safe area and reliable touch targets. */
@media (max-width: 600px) {
  .pk-mobile-nav {
    height: calc(75px + env(safe-area-inset-bottom));
    padding-bottom: calc(6px + env(safe-area-inset-bottom));
  }

  .pk-mobile-nav button,
  .pk-mobile-battle-link,
  .pk-side-link,
  .pk-notice-link,
  .pk-auth-actions button,
  .pk-live-item {
    touch-action: manipulation;
  }

  .pk-mobile-battle-link,
  .pk-side-link,
  .pk-notice-link,
  .pk-auth-actions button {
    min-height: 44px;
  }

  .pk-live {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
